import { WorkspacePremium } from "@mui/icons-material"
import { Button, useGetIdentity, useGetOne, useNotify, usePermissions } from 'react-admin'
import { apiService } from "../../apiService"
import { AppId, OrderSubscriptionCommand, UserReadModel } from "../../GeneratedClients/FreeBillApi"
import { useState } from "react"
import { Permissions } from "../../authentication/Permissions"
import CompleteUserDataDialog from "./CompleteUserDataDialog"

const OrderSubscriptionButton = ({size}: {size?: "large" | "medium" | "small"}) => {

  const {isLoading: identityIsLoading, data: identity} = useGetIdentity()
  const {isLoading: permissionsLoading, permissions} = usePermissions<Permissions>()
  //@ts-ignore
  const {data: user, isLoading: userIsLoading} = useGetOne<UserReadModel>("users", {id: identity?.id}, {enabled: !identity}) 
  const [completeUserData, setCompleteUserData] = useState<boolean>(false)
  const notify = useNotify()

  const userDataIncomplete = () => {
    if(
      !user?.company?.city
      || !user?.company?.companyName
      || !user?.company?.city
      || !user?.company?.email
      || !user?.contact?.lastName
      || !user?.company?.postCode
      || !user?.company?.street
    ) {
      setCompleteUserData(true)
      return true
    }
    return false
  }

  const handleClick = async() => {
    if(userDataIncomplete()) return
    try {
      if(user?.id) {
        var location = window.location
        var callbackUrl = location.href
        var orderSubscriptionCommand: OrderSubscriptionCommand = {
          userId: user?.id,
          appId: permissions.redirectToFff ? AppId.Fff : AppId.Fbl,
          callbackUrl: callbackUrl,
          city: user?.company?.city,
          companyName: user?.company?.companyName,
          email: user?.company?.email,
          fullName: `${user?.contact?.firstName ? `${user?.contact?.firstName} ` : ""}${user?.contact?.lastName}`,
          postCode: user?.company?.postCode,
          streetNameAndNumber: user?.company?.street
        }
        var {data: url} = await apiService.UsersApi.orderSubscription({userId: user?.id, orderSubscriptionCommand: orderSubscriptionCommand })
        location.replace(url)
      }
    } catch (error: any) {
      console.log(error)
      notify(`${error.response.data}`, {type: "error"})
    }
  }

  if(identityIsLoading || userIsLoading || permissionsLoading) return null

  return (
    <>
      {completeUserData && <CompleteUserDataDialog open={completeUserData} setOpen={setCompleteUserData} />}
      <Button size={size} startIcon={<WorkspacePremium />} label="Paket ändern" onClick={handleClick} />
    </>
    
  )
}

export default OrderSubscriptionButton